import React from "react";
import { stylex } from "./stylex";

interface ColumnProps {
  children?: React.ReactNode;
  justifyContent?: "flex-start" | "flex-end" | "space-between" | "center";
  alignItems?: "flex-start" | "flex-end" | "space-between" | "center";
  overflow?: "hidden" | "visible";
  flex?: number;
  expanded?: boolean;
}

/**
 * Displays its children in a vertical array.
 */
export function Column(props: ColumnProps) {
  const { children, flex, overflow, justifyContent, alignItems, expanded } =
    props;

  return (
    <div
      style={{
        ...styles("root", expanded && "expanded"),
        justifyContent,
        alignItems,
        overflow,
        flex,
      }}
    >
      {children}
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  expanded: {
    height: "100%",
    width: "100%",
  },
});
